import { render, staticRenderFns } from "./tzproduct4.vue?vue&type=template&id=482ecd43&scoped=true"
import script from "./tzproduct4.vue?vue&type=script&lang=js"
export * from "./tzproduct4.vue?vue&type=script&lang=js"
import style0 from "./tzproduct4.vue?vue&type=style&index=0&id=482ecd43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482ecd43",
  null
  
)

export default component.exports